export default class {
    constructor() {
        this.path = '/actions/site-module/csrf/get-token';
    }

    async getCsrfToken() {
        return window.CSRF || await this.fetchCsrfToken();
    }

    async fetchCsrfToken() {
        const response = await fetch(this.path, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });

        const json = await response.json();

        if (!json.hasOwnProperty('data') && !json['data'].hasOwnProperty('tokenName')) {
            console.warn('Error getting CSRF token. Invalid response signature.');
            return;
        }

        window.CSRF = {
            name: json['data']['tokenName'],
            value: json['data']['tokenValue'],
        }

        return window.CSRF;
    }
}
